<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Phone Model</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">Save</el-button>
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits service="Phone Model" :record="selectedPhoneModel" />
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Config" name="Config">
          <el-input placeholder="Enter name" v-model="editForm.name">
            <template slot="prefix">Name</template>
          </el-input>

          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                placeholder="Enter start line"
                type="number"
                v-model="editForm.startline"
              >
                <template slot="prefix">Start line</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input placeholder="Enter end line" type="number" v-model="editForm.endline">
                <template slot="prefix">End line</template>
              </el-input>
            </el-col>
          </div>

          <h2 class="form-section-header">Config request</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter XML phone configuration"
            v-model="editForm.mac"
          />

          <h2 class="form-section-header">Directory request</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter XML directory configuration"
            v-model="editForm.directory"
          />
        </el-tab-pane>
        <el-tab-pane label="Provisioning" name="Provisioning">
          <h2 class="form-section-header">Remote provisioning POST message</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter remote provisioning POST message"
            v-model="editForm.remotePost"
          />
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                placeholder="Enter provisioning URL"
                v-model="editForm.remotePostUrl"
              >
                <template slot="prefix">URL</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                placeholder="Enter POST content type"
                v-model="editForm.remotePostContentType"
              >
                <template slot="prefix">Content type</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                placeholder="Enter provisioning user"
                v-model="editForm.remotePostUser"
              >
                <template slot="prefix">User</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                placeholder="Enter provisioning password"
                v-model="editForm.remotePostPassword"
              >
                <template slot="prefix">Password</template>
              </el-input>
            </el-col>
          </div>
          <h2 class="form-section-header">Remote deregister POST message</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter remote provisioning POST message"
            v-model="editForm.remotePostDeregister"
          />
        </el-tab-pane>
      </el-tabs>

    </el-form>
  </el-dialog>
</template>

<script>

import RecentAudits from '@/components/RecentAudits';

export default {
  name: "PhoneModelEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedPhoneModel: { required: true }
  },

  components: { RecentAudits },

  data() {
    return {
      activeTab: 'Config',
      editForm: {
        name: '',
        mac: '',
        directory: '',
        remotePost: '',
        remotePostUrl: '',
        remotePostUser: '',
        remotePostPassword: '',
        remotePostContentType: '',
        remotePostDeregister: '',
        startline: null,
        endline: null
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedPhoneModel(val) {
      if (val) {
        const {
          name,
          mac,
          directory,
          remotePost,
          remotePostUrl,
          remotePostUser,
          remotePostPassword,
          remotePostContentType,
          remotePostDeregister,
          startline,
          endline
        } = val;

        this.editForm.name = name;
        this.editForm.mac = mac;
        this.editForm.directory = directory;
        this.editForm.remotePost = remotePost;
        this.editForm.remotePostUrl = remotePostUrl;
        this.editForm.remotePostUser = remotePostUser;
        this.editForm.remotePostPassword = remotePostPassword;
        this.editForm.remotePostContentType = remotePostContentType;
        this.editForm.startline = startline;
        this.editForm.endline = endline;
        this.editForm.remotePostDeregister = remotePostDeregister;
      }
    }
  },

  methods: {
    editOperation() {
      this.$emit("editOperation", this.editForm);
    },

    validateXml(xmlStr, title) {
      if (!xmlStr) return true;

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlStr, "text/xml");

      if (xmlDoc.querySelectorAll("parsererror").length > 0) {
        // ⭐️ Notify User ⭐️ //
        this.$notify({
          title: `Invalid XML for ${title}.`,
          message: "Please enter a valid XML string.",
          type: "error"
        });
        return false;
      }
      return true;
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      Object.keys(this.editForm).forEach(key => {
        this.editForm[key] = "";
      });
      this.editForm.startline = null;
      this.editForm.endline = null;
      this.activeTab = 'Config';
    }
  }
};
</script>

<style lang="scss" scoped>

.el-tabs{
  max-width: 600px;
  margin: auto;
}

</style>
